import { Component, OnInit, Input } from "@angular/core";
import { EdtellCardConfig } from "../../interface/edtell-card-config.interface";

@Component({
  selector: "app-edtell-card-container",
  templateUrl: "./edtell-card-container.component.html",
  styleUrls: ["./edtell-card-container.component.scss"],
})
export class EdtellCardContainerComponent {
  @Input()
  title: string;

  @Input()
  height100: boolean;
}
